import { Pipe, PipeTransform } from '@angular/core';

/**
 * Unescape HTML by rendering and fetching it to/from a
 * textarea element.
 *
 * @note The default js `decodeURI` only works for URLS,
 *  and `unescape` is not supported by TypeScript.
 */
@Pipe({
  name: 'unescape'
})
export class UnescapePipe implements PipeTransform {

  /**
   * Unescape/decode HTML.
   *
   * @param html The encoded HTML string.
   * @returns Decoded HTML string.
   */
  transform(html: string): string {
    const el = document.createElement('textarea');
    el.innerHTML = html;
    return el.value;
  }
}
